"use client";

import { useReducedMotion } from "framer-motion";

export const easeOut = [0.22, 1, 0.36, 1] as const;

export const fadeUp = {
  hidden: { opacity: 0, y: 12 },
  visible: { opacity: 1, y: 0 },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

export const fadeScale = {
  hidden: { opacity: 0, y: 8, scale: 0.99 },
  visible: { opacity: 1, y: 0, scale: 1 },
};

export const staggerContainer = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.04, delayChildren: 0 },
  },
};

export function useMotionSafe() {
  const prefersReducedMotion = useReducedMotion();
  return {
    prefersReducedMotion: Boolean(prefersReducedMotion),
    transition: prefersReducedMotion
      ? { duration: 0 }
      : { duration: 0.35, ease: easeOut },
    // Expand the bottom of the root so reveals start as content approaches,
    // not after it is already well into the viewport.
    viewport: { once: true, amount: 0.05, margin: "0px 0px 25% 0px" as const },
  };
}
